import { IToastConfig } from 'src/common/primitives/Toast';

export function generateMemberDeleteSuccessToast(id: number): IToastConfig {
  return {
    id,
    title: `The member has been deleted`,
  };
}
